module.exports = __webpack_public_path__ + "img/item1-1.deab87db.png";